import { useState, useEffect } from 'react';
import ToggleForm from '../../../components/toggle/ToggleForm';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

const defaultProps = {
  profile: {},
  onChangeCallback: () => {},
};

const ExitLesson = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { profile, onChangeCallback } = mergedProps;
  const [toggle, setToggle] = useState(profile.exitLesson);
  const isExitLesson = profile.exitLesson;
  // When mounting and changing a profile.
  useEffect(() => {
    setToggle(isExitLesson);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.id]);

  const handleExitLessonOnchange = (field, newValue) => {
    if (newValue === null) return;
    setToggle(newValue);
    onChangeCallback(newValue);
  };

  return (
    <ToggleForm value={toggle} handleOnChange={handleExitLessonOnchange} />
  );
};

export default ExitLesson;
